<template>
  <div v-if="!loading" class="pt-8 pb-6 item">
    <v-container class="py-0">
      <div
        class="secondary--text text-h5 text-md-h4 text-center font-weight-bold"
      >
        MTR
      </div>

      <v-row
        class="my-0"
        justify="center"
        justify-md="space-between"
        align="center"
      >
        <v-col v-if="item.video" class="mt-2" cols="auto" md="4" lg="auto">
          <v-btn
            @click="dialog = true"
            class="text-none"
            color="transparent"
            height="50px"
            depressed
          >
            <img
              class="d-block mr-3"
              src="../../assets/img/icons/play.svg"
              width="35px"
            />
            <div
              class="white--text text-subtitle-1 font-weight-medium btn-text"
            >
              Vídeo de Orientações MTR
            </div>
          </v-btn>
        </v-col>

        <v-col v-if="item.sinir_link" class="mt-2" cols="auto" md="4" lg="auto">
          <v-btn
            class="text-none"
            color="transparent"
            :href="item.sinir_link"
            target="_blank"
            height="50px"
            depressed
          >
            <img
              class="d-block mr-3"
              src="../../assets/img/icons/cursor.svg"
              width="35px"
            />
            <div
              class="white--text text-subtitle-1 font-weight-medium btn-text"
            >
              Acessar o site SINIR.GOV.BR
            </div>
          </v-btn>
        </v-col>

        <v-col class="mt-2" cols="auto" md="4" lg="auto">
          <v-btn
            class="text-none"
            color="transparent"
            to="/contato"
            height="50px"
            depressed
          >
            <img
              class="d-block mr-3"
              src="../../assets/img/icons/contact.svg"
              width="35px"
            />
            <div
              class="white--text text-subtitle-1 font-weight-medium btn-text"
            >
              Dúvidas? Fale Conosco.
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog content-class="dialog-video" v-model="dialog" max-width="960">
      <div class="black position-relative video">
        <div class="model-close">
          <v-btn
            @click="dialog = false"
            color="grey darken-3"
            width="38px"
            height="38px"
            depressed
            fab
          >
            <v-icon color="white" size="20"> fa-times </v-icon>
          </v-btn>
        </div>

        <iframe
          width="560"
          height="315"
          :src="
            dialog
              ? 'https://www.youtube.com/embed/' +
                getYoutubeCode(item.video) +
                '?autoplay=1'
              : ''
          "
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { getYoutubeCode } from "../../utils/getYoutubeCode";

const _config = {
  mod: "configMtr",
};

export default {
  data: () => ({
    loading: true,
    dialog: false,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  methods: {
    getYoutubeCode,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background: linear-gradient(180deg, #003399 0%, #0051ac 100%);

  .btn-text {
    margin-top: 2px;
  }
}
</style>
